module.exports = __webpack_public_path__ + "static/media/tapleyjung3.38644a77.ogg";